// Mirrors ogiso-backend/routes/skypointProvider.route.js#canAddProviders —
// kept in sync by hand since the two repos share no code. This only decides
// whether to show the Add Provider button; the real gate is the backend's
// 403 on POST /skypointProvider and POST /skypointProvider/external.
export const canAddProviders = (profile, whoCanAdd) => {
  const allowed = whoCanAdd?.length ? whoCanAdd : ["admin", "adminStaff"];
  const isStaff = profile?.type?.toLowerCase?.() === "staff" || profile?.role === "staff";
  const isAdmin = profile?.role === "admin" || profile?.type === "admin" || !isStaff;
  const isAdminStaff = isStaff && profile?.role === "admin";
  if (allowed.includes("allStaff") && isStaff) return true;
  if (allowed.includes("adminStaff") && isAdminStaff) return true;
  if (allowed.includes("admin") && isAdmin) return true;
  return false;
};
